import React, { useEffect, useMemo, useState } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import PatientListPage from "./patients/PatientListPage";
import PatientChartPage from "./patients/PatientChartPage";
import HQTracker from "./app/HQ";

const STORAGE_KEY = "fieldAccessHQ";
const TAB_KEY = "fieldAccessHqActiveTab";

export default function HQPage({ openInventoryModal }) {
  const [loading, setLoading] = useState(true);
  const [unlocked, setUnlocked] = useState(false);
  const [activeTab, setActiveTab] = useState("tracker");
  const [totalPatientsAtHQ, setTotalPatientsAtHQ] = useState(0);
  const [openInventoryHandler, setOpenInventoryHandler] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const fieldAccessSource = sessionStorage.getItem("fieldAccessSource");
  const isDispatchMode =
  fieldAccessSource === "dispatch";

const isCommandMode =
  fieldAccessSource === "command";

const canReturnToDispatch =
  (isDispatchMode || isCommandMode) &&
  sessionStorage.getItem("fieldAccessDispatch") === "true";

  useEffect(() => {
    const unlockedSession = sessionStorage.getItem(STORAGE_KEY);
    const savedTab = sessionStorage.getItem(TAB_KEY);

    if (unlockedSession === "true") setUnlocked(true);

    if (savedTab === "patients" || savedTab === "tracker") {
      setActiveTab(savedTab);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    sessionStorage.setItem(TAB_KEY, activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

 const isChartRoute = useMemo(
  () => location.pathname.startsWith("/field-access/hq/patients/"),
  [location.pathname]
);

  function handleLock() {
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(TAB_KEY);

    if (sessionStorage.getItem("fieldAccessSource") === "hq") {
      sessionStorage.removeItem("fieldAccessSource");
    }

    window.location.href = "/field-access/hq";
  }

  function goPatients() {
  setActiveTab("patients");
  navigate("/field-access/hq/patients");
}

  function goTracker() {
  setActiveTab("tracker");
  navigate("/field-access/hq");
}

  function goDispatch() {
    navigate("/field-access/dispatch");
  }

  if (loading) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

 if (!unlocked) {
  return null;
}

  return (
    <div style={styles.shell}>
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.titleWrap}>
            <div style={styles.title}>HQ</div>
            <div style={styles.subtitle}>
              {isChartRoute
                ? "Patient Chart"
                : activeTab === "tracker"
                ? "PT Tracker"
                : "Patients"}
            </div>
          </div>

        <div style={styles.tabs}>
  <button
    type="button"
    style={
      activeTab === "tracker" && !isChartRoute
        ? styles.tabActive
        : styles.tab
    }
    onClick={goTracker}
  >
    PT Tracker
  </button>

  {!isDispatchMode && (
    <button
      type="button"
      style={
        activeTab === "patients" && !isChartRoute
          ? styles.tabActive
          : styles.tab
      }
      onClick={goPatients}
    >
      Patients
    </button>
  )}

  {(isDispatchMode || isCommandMode) && (
    <button type="button" onClick={goDispatch} style={styles.tab}>
      Dispatch
    </button>
  )}

  {isCommandMode && (
    <button
      type="button"
      onClick={() => navigate("/field-access/command")}
      style={styles.tab}
    >
      Command
    </button>
  )}
</div>
        </div>

        <div style={styles.patientCount}>
          Total PTs at HQ: {totalPatientsAtHQ}
        </div>

        

        <div style={styles.navRight}>

          <button
  type="button"
  onClick={openInventoryHandler}
  disabled={!openInventoryHandler}
  style={{
    background: "#1e293b",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.2)",
    borderRadius: 10,
    padding: "10px 14px",
    fontWeight: 800,
    cursor: "pointer",
    marginRight: 10,
  }}
>
  Inventories
</button>
          <button onClick={handleLock} style={styles.lockBtn}>
            Lock
          </button>
        </div>
      </div>

      <div style={styles.content}>
       <div
  style={{
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    overflowX: "hidden",
    boxSizing: "border-box",
  }}
>
          <Routes>
            <Route
              index
              element={
                activeTab === "tracker" ? (
                  <HQTracker
                  onTotalPatientsChange={setTotalPatientsAtHQ}
                  onInventoryHandlerReady={setOpenInventoryHandler}
                />
                ) : (
                  <PatientListPage />
                )
              }
            />

            <Route path="patients" element={<PatientListPage />} />
            <Route path="patients/:patientId" element={<PatientChartPage />} />

           <Route path="*" element={<Navigate to="/field-access/hq" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

const isPhone = window.innerWidth <= 640;

const styles = {
  shell: {
  height: "100vh",
  width: "100%",
  maxWidth: "100vw",
  display: "flex",
  flexDirection: "column",
  background: "#f8fafc",
  overflowX: "hidden",
  overflowY: "auto",
  boxSizing: "border-box",
},
  header: {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
  padding: "10px 14px",
  background: "#0f172a",
  borderBottom: "1px solid #1e293b",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  overflowX: "hidden",
},
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 18,
    minWidth: 0,
    flexWrap: "wrap",
  },
  titleWrap: {
    display: "grid",
    gap: 2,
    minWidth: 0,
  },
  title: {
    color: "#f8fafc",
    fontWeight: 900,
    fontSize: 18,
    lineHeight: 1,
  },
  subtitle: {
    color: "#94a3b8",
    fontSize: 12,
    fontWeight: 700,
  },
 tabs: {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
  width: isPhone ? "100%" : "auto",
},
  tab: {
    padding: "8px 12px",
    background: "#1e293b",
    color: "#fff",
    border: "1px solid #334155",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
  },
  tabActive: {
    padding: "8px 12px",
    background: "#0ea5e9",
    color: "#fff",
    border: "1px solid #38bdf8",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
  },
 patientCount: {
  color: "#ffffff",
  fontWeight: 800,
  fontSize: 14,
  marginLeft: "auto",
  marginRight: 14,
  whiteSpace: "nowrap",
  width: isPhone ? "100%" : "auto",
  textAlign: isPhone ? "center" : "right",
},
 navRight: {
  display: "flex",
  gap: 10,
  marginRight: 10,
  flexWrap: "wrap",
  width: isPhone ? "100%" : "auto",
},
  lockBtn: {
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  content: {
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
},
};